import { render, staticRenderFns } from "./memberCardCheckDocumentation.vue?vue&type=template&id=e204d7ca&"
import script from "./memberCardCheckDocumentation.vue?vue&type=script&lang=js&"
export * from "./memberCardCheckDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports